// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { EditProcessChainRequestSchema, EditProcessChainResponseSchema } from './edit-process-chain.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const editProcessChainContract = {
    method: 'PUT',
    path: '/api/v2/process-chains/:id',
    description: 'Edit an existing process chain',
    requestSchema: EditProcessChainRequestSchema,
    responseSchema: EditProcessChainResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body or circular parent reference',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Chain not found'
        }
    }
};

//# sourceMappingURL=edit-process-chain.contract.js.map